import {CP_ID, NCP_ID} from '@evencel/api';
import {IActivity, ICpNcpAssignment, IParticipant} from '../entity';

export function mapCpNcpParticipants(activity: IActivity, cpNcpAssignments?: ICpNcpAssignment[]) {
    return cpNcpAssignments
        ?.filter(f => f.status?._id === CP_ID || f.status?._id === NCP_ID)
        .map(cp => {
            const p = activity.participants?.find(p => p._id === cp.participant._id);
            if (p) cp.participant = p;
            return cp;
        });
}

export function getCpNcParticipantsOnly(cpNcpAssignments?: ICpNcpAssignment[], participants?: IParticipant[]) {
    return cpNcpAssignments
        ?.filter(f => f.status?._id === CP_ID || f.status?._id === NCP_ID)
        .map(cp => {
            const clone = {...cp};
            const p = participants?.find(p => p._id === cp.participant._id);
            if (p) {
                clone.participant = p;
            }
            return clone;
        });
}

export function haveLeastCpOrNcp(cpNcps: ICpNcpAssignment[]) {
    // least one CP and NCP should be there
    const haveCP = cpNcps.some(c => c.status?._id === CP_ID);
    const haveNCP = cpNcps.some(c => c.status?._id === NCP_ID);
    return haveCP && haveNCP;
}

export function haveLeastCpOrNcpAndSubmissionDate(cpNcps: ICpNcpAssignment[]) {
    const haveCP = cpNcps.some(c => c.status?._id === CP_ID && c.caseTakenSubmissionDate !== null);
    const haveNCP = cpNcps.some(c => c.status?._id === NCP_ID && c.caseTakenSubmissionDate !== null);
    return haveCP && haveNCP;
}

export function getPmpInvoiceId(start: Date, end: Date, acronym: string) {
    const e = dateWithoutTimezone(end);
    const s = dateWithoutTimezone(start);
    return `${acronym} ${s} - ${e}`;
}

export function dateWithoutTimezone(date: Date) {
    const withoutTimezone = date.toISOString().slice(0, 10);
    const f = new Date(withoutTimezone).toLocaleString('en-Us', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC',
    });
    return f;
}

export function dateWithoutTimezoneYY(date: string | Date) {
    if (typeof date !== 'string') {
        date = date.toISOString().slice(0, 10);
    }

    const withoutTimezone = date.slice(0, 10);
    const f = new Date(withoutTimezone).toLocaleString('en-Us', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        timeZone: 'UTC',
    });
    return f;

    // const withoutTimezone =
    // const f = new Date(withoutTimezone).toLocaleString('en-Us', {
    //     day: '2-digit',
    //     month: '2-digit',
    //     year: '2-digit',
    //     timeZone: 'UTC',
    // });
    // return f;
}
